import { render } from "./AICreateView.vue?vue&type=template&id=1b5c2e16"
import script from "./AICreateView.vue?vue&type=script&lang=js"
export * from "./AICreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__